module.exports = __webpack_public_path__ + "static/media/18ECA49.ff3ee548.jpg";